import { setCrudSelection, setEditingState, setMainSelection } from '@/atoms'
import { getRouterNavigator } from '@/routing'
import { gis } from '@/server-data'

import { fitMap } from '../../../../atoms/map/utils/fitMap'
import { getMapSelectionContext } from '../../../../atoms/selection/read/getMapSelectionContext'
import { getDomainMarkerData } from '../../../../atoms/markerChangelog/domain/getDomainMarkerData'

export function doubleClickPlaces(placeId?: string) {
  if (placeId) {
    const { mapMarkers } = getDomainMarkerData()
    const { type: selectionCtx } = getMapSelectionContext()

    const latLngCoordinates: uui.domain.LatLng[] = []

    const place = mapMarkers.place[placeId]

    if (!place) {
      if (process.env.NODE_ENV === 'development') {
        throw new Error(`Trying to double click a non-existent Place with ID: ${placeId}`)
      }

      return
    }

    latLngCoordinates.push(gis.fromCoordinateToLatLng(place.lonLat))

    // Set the new selection for both selectionContexts
    setMainSelection('places', [placeId])
    setCrudSelection('places', [placeId])

    // queue a pending fitMap request
    // it will be applied by the destination view when it opens
    fitMap(latLngCoordinates, { preventIfVisible: true }, 'add')

    // If the double click has been performed in the Setup Map let's set the editing state
    if (selectionCtx === 'crud') {
      setEditingState({ editing: true, ctx: 'place', editingEntities: [placeId] })
    }

    // Navigate to the target page
    const navigate = getRouterNavigator()
    navigate('/setup/places')
  }
}
